// /* tslint:disable */
/* eslint-disable */

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {catchError, Observable, retry, throwError,} from 'rxjs';
import {Inject, Injectable, Optional} from '@angular/core';
import {BOKKZ_SERVICE_URL,} from './api.bokkz.services';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {

  private http: HttpClient;
  private baseUrl: string;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BOKKZ_SERVICE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Headers':'Access-Control-Allow-Origin',
      // 'Accept-Language' : 'nl_NL',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Accept: 'application/json',
    }),
  };

  getTemplate(type: string): Observable<TemplateEntity> {
    return this.http
      .get<TemplateEntity>(this.baseUrl + `/api/v1/sst/template/${type}`, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  postTemplate(entity: TemplateEntity): Observable<TemplateEntity> {
    return this.http
      .post<TemplateEntity>(this.baseUrl + `/api/v1/sst/template/`, entity, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  handleError(error: { error: { message: string }; status: number; message: string }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}

export interface TemplateEntity {

  id?: number
  type?: string;
  officeLogoPosition?: TemplateOptions;
  logoFirstPage?: number[] | string | { data: number[] };
  logoContinuationPage?: number[] | string | { data: number[] };
  footerType?: string;
  footerImage?: number[] | string | { data: number[] };
  footerText?: string;
  font?: string;
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;

  [key: string]: any;

}

export enum TemplateOptions {
  none= "NONE",
  left= "left",
  right= "right",
  center= "center",
}
